package game.controller

import com.soywiz.korge.input.Input
import com.soywiz.korui.layout.MathEx.max
import com.soywiz.korui.layout.MathEx.min
import game.*
import game.entity.Direction
import game.entity.Direction.*
import view.Terminal

class ScrollTransitionController : GameController() {
    private lateinit var destRoom: Room
    private lateinit var sourceRoom: Room
    private var sourceCol = 0
    private var sourceRow = 0
    private var destCol = 0
    private var destRow = 0
    private var previousRoom: Room? = null
    private var lightRadius = 0
    private var playerScrollCol = 0
    private var playerScrollRow = 0
    var direction = North
    private var coolDown = 0.0
    private var transitionDuration = ROOM_WIDTH.toDouble()
    private val ratio: Double
        get() = (transitionDuration - coolDown) / transitionDuration

    override fun onActivate(game: Game) {
        lightRadius = game.player.lightSource.radius
    }

    override fun onDeactivate(game: Game) {
    }

    override fun onTick(game: Game, input: Input) {
        if (coolDown <= 0.0) {
            game.controller = PlayController()
        } else {
            coolDown--
        }
    }

    private fun renderScrollNorth(game: Game, terminal: Terminal, playerCol: Int, playerRow: Int) {
        val splitRow = (ratio * ROOM_HEIGHT).toInt()

        renderVerticalScroll(terminal, splitRow, destRoom, sourceRoom)
    }

    private fun renderScrollSouth(game: Game, terminal: Terminal, playerCol: Int, playerRow: Int) {
        val splitRow = ROOM_HEIGHT - (ratio * ROOM_HEIGHT).toInt()

        renderVerticalScroll(terminal, splitRow, sourceRoom, destRoom)
    }

    private fun renderScrollEast(game: Game, terminal: Terminal, playerCol: Int, playerRow: Int) {
        val splitCol = ROOM_WIDTH - (ratio * ROOM_WIDTH).toInt()

        renderHorizontalScroll(terminal, splitCol, sourceRoom, destRoom)
    }

    private fun renderScrollWest(game: Game, terminal: Terminal, playerCol: Int, playerRow: Int) {
        val splitCol = (ratio * ROOM_WIDTH).toInt()

        renderHorizontalScroll(terminal, splitCol, destRoom, sourceRoom)
    }

    private fun renderVerticalScroll(terminal: Terminal, splitRow: Int, topRoom: Room, bottomRoom: Room) {
        playerScrollRow = splitRow

        val playerCol = playerScrollCol
        var playerRow = ROOM_HEIGHT

        topRoom.render(
            terminal,
            ROOM_LEFT_COL,
            ROOM_TOP_ROW,
            0,
            ROOM_HEIGHT - splitRow,
            ROOM_WIDTH,
            splitRow,
            topRoom.dark,
            lightRadius,
            playerCol,
            playerRow
        )

        playerRow = 0

        bottomRoom.render(
            terminal,
            ROOM_LEFT_COL,
            ROOM_TOP_ROW + splitRow,
            0,
            0,
            ROOM_WIDTH,
            ROOM_HEIGHT - splitRow,
            bottomRoom.dark,
            lightRadius,
            playerCol,
            playerRow
        )
    }

    private fun renderHorizontalScroll(
        terminal: Terminal,
        splitCol: Int,
        leftRoom: Room,
        rightRoom: Room,
    ) {
        playerScrollCol = splitCol

        var playerCol = ROOM_WIDTH
        val playerRow = playerScrollRow

        leftRoom.render(
            terminal,
            ROOM_LEFT_COL,
            ROOM_TOP_ROW,
            ROOM_WIDTH - splitCol,
            0,
            splitCol,
            ROOM_HEIGHT,
            leftRoom.dark,
            lightRadius,
            playerCol,
            playerRow
        )

        playerCol = 0

        rightRoom.render(
            terminal,
            ROOM_LEFT_COL + splitCol,
            ROOM_TOP_ROW,
            0,
            0,
            ROOM_WIDTH - splitCol,
            ROOM_HEIGHT,
            rightRoom.dark,
            lightRadius,
            playerCol,
            playerRow
        )
    }

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderUi(terminal)
        playerScrollCol = game.player.col
        playerScrollRow = game.player.row

        when (direction) {
            North -> renderScrollNorth(game, terminal, playerScrollCol, playerScrollRow)
            South -> renderScrollSouth(game, terminal, playerScrollCol, playerScrollRow)
            East -> renderScrollEast(game, terminal, playerScrollCol, playerScrollRow)
            West -> renderScrollWest(game, terminal, playerScrollCol, playerScrollRow)
        }

        playerScrollCol = max(0, min(ROOM_WIDTH, playerScrollCol));
        playerScrollRow = max(0, min(ROOM_HEIGHT, playerScrollRow));

        with(terminal.getChar(playerScrollCol + ROOM_LEFT_COL, playerScrollRow + ROOM_TOP_ROW)) {
            char = 2
            bgColor = fgColor  // Make fgColor the background--blends better!
            fgColor = CgaColor.LIGHT_BLUE.rgba
        }
    }

    fun startScrollTransition(sourceRoom: Room, destRoom: Room, direction: Direction) {
        coolDown = transitionDuration
        this.sourceRoom = sourceRoom
        this.destRoom = destRoom
        this.direction = direction
    }
}